export default __webpack_public_path__ + "static/media/18_4_0.d2e24151.png";